import React from 'react'
import {Bars} from '../../Module_Exporter/Module_Exporter';

function Headings(ops) {

  if(ops.justheading!==true)
  {
    
    
    return (
    <div   className={ops.cl+" sections_heading"}>
      
    <div data-aos={ops.aos}>
      
      <Bars  width={ops.w} height={ops.h} color={ops.c}/>
      <h2 className='heading'>{ops.title1} <span>{ops.title2}</span></h2>
    </div>
      <p data-aos={ops.text_aos} >{ops.text}</p>
  </div>
  )
}
else{
  return (
    <div className={ops.cl+" sections_heading"}>
      
    <div>
      
      <Bars  width={ops.w} height={ops.h} color={ops.c}/>
      <h2 className='heading'>{ops.title1} <span>{ops.title2}</span></h2>
    </div>
      
  </div>
  )
}



}

Headings.defaultProps={
    title1:"Title",
    title2:"Here",
    text:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore est eveniet tempor.Lorem ipsum dolor sit amet consectetur.",
    w:"40%",
    h:"0.3rem",
    c:"c1",
    cl:"Nothing",
    aos:"nothing",
    text_aos:"nothing"

}

export default Headings